import createActions from '../../config/actions/createActions';
import { action } from '@play-co/replicant';
import { Match2DailyChallengeGoal } from './match2-dailychallenge.ruleset';
import {
  getDailyChallengeRewardGems,
  isDailyChallengeComplete,
  shouldSyncDailyChallenge,
} from './match2-dailychallenge.getters';
import {
  progressDailyChallenge,
  resetDailyChallenge,
} from './match2-dailychallenge.modifiers';
import { grantMatch2Rewards } from '../match2.modifiers';

export type Match2ProgressDailyChallengeArgs = {
  goal: Match2DailyChallengeGoal;
  amount: number;
};

export const match2DailyChallengesActions = createActions({
  setMatch2DailyChallengeAutoPopupShown: action((state) => {
    if (!state.match2.dailyChallenge) return;
    state.match2.dailyChallenge.autoPopupShown = true;
  }),

  syncMatch2DailyChallenge: action((state, _, api) => {
    const now = api.date.now();

    // Skip if daily challenge should not sync
    if (!shouldSyncDailyChallenge(state, now)) return;

    resetDailyChallenge(state, now);
  }),

  triggerMatch2DailyChallengeUpdate: action(
    (state, args: Match2ProgressDailyChallengeArgs[]) => {
      if (!state.match2.dailyChallenge || isDailyChallengeComplete(state))
        return;
      args.forEach(({ goal, amount }) => {
        progressDailyChallenge(state, amount, goal);
      });
    },
  ),

  claimMatch2DailyChallengeRewards: action((state, _: void, api) => {
    if (
      !state.match2.dailyChallenge ||
      state.match2.dailyChallenge.rewardsClaimed
    )
      return;

    const gems = getDailyChallengeRewardGems(state);

    if (!gems) return;
    grantMatch2Rewards(
      state,
      [{ type: 'gems', amount: gems }],
      { feature: 'match_daily_challenge_rewards_claimed' },
      api,
    );
    state.match2.dailyChallenge.rewardsClaimed = true;
  }),
});
